import { theme } from '@aloft/toolkit-sui';
import { Box } from '@aloft/toolkit-sui/chakra';

const FILL = theme.colors.blue[500];

const spinSx = {
  display: 'inline-flex',
  flexShrink: 0,
  width: '16px',
  height: '16px',
  animation: 'uadRatingsSpinnerRotate 0.8s linear infinite',
  '@keyframes uadRatingsSpinnerRotate': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
};

export const UADRatingsSpinner = () => (
  <Box sx={spinSx}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="6.93359"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        fill={FILL}
        fillOpacity="0.6"
      />
      <rect
        x="6.93359"
        y="10.6667"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        fill={FILL}
        fillOpacity="0.2"
      />
      <rect
        y="9.06665"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        transform="rotate(-90 0 9.06665)"
        fill={FILL}
        fillOpacity="0.2"
      />
      <rect
        x="1.59961"
        y="3.10864"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        transform="rotate(-45 1.59961 3.10864)"
        fill={FILL}
        fillOpacity="0.4"
      />
      <rect
        x="9.06641"
        y="10.5752"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        transform="rotate(-45 9.06641 10.5752)"
        fill={FILL}
        fillOpacity="0.2"
      />
      <rect
        x="5.37109"
        y="9.06665"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        transform="rotate(45 5.37109 9.06665)"
        fill={FILL}
        fillOpacity="0.2"
      />
      <rect
        x="12.8379"
        y="1.6001"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        transform="rotate(45 12.8379 1.6001)"
        fill={FILL}
        fillOpacity="0.8"
      />
      <rect
        x="10.667"
        y="9.06665"
        width="2.13333"
        height="5.33333"
        rx="1.06667"
        transform="rotate(-90 10.667 9.06665)"
        fill={FILL}
      />
    </svg>
  </Box>
);
